import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './assets/css/style.css';
import { useSelector } from 'react-redux';
import { BrowserRouter, useRoutes, useLocation, Navigate } from 'react-router-dom';
import { UserRoutes } from './routes/userRoutes';
import AuthRoutes from './routes/authRoutes';

function App() {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  const UserRoutesPage = () => {
    const allPages = useRoutes(UserRoutes);
    return allPages;
  };

  const AuthRoutesPage = () => {
    const allPages = useRoutes(AuthRoutes);
    return allPages;
  };

  const queryClientOption = {
    defaultOptions: {
      queries: { refetchOnWindowFocus: false, retry: false, staleTime: 1000 * 5 },
    },
  };
  const queryClient = new QueryClient(queryClientOption);

  const RouterSwitch = () => {
    const location = useLocation();
    if (isLoggedIn && location.pathname === '/login') {
      return <Navigate to="/cms/quan-ly-hoc-vien" replace />;
    }
    return isLoggedIn ? <UserRoutesPage /> : <AuthRoutesPage />;
  };

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <RouterSwitch />
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
